module.exports = __webpack_public_path__ + "img/img4.64dbb448.jpg";